import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import { Toaster } from 'sonner';
import Layout from './components/shared/Layout';
import ErrorBoundary from './components/ErrorBoundary';

// Lazy load components for code splitting
const LandingPage = lazy(() => import('./components/LandingPage'));
const BedtimeStoryGenerator = lazy(() => import('./components/BedtimeStoryGenerator'));
const PrivacyPolicy = lazy(() => import('./components/PrivacyPolicy'));
const TermsOfService = lazy(() => import('./components/TermsOfService'));
const ContactUs = lazy(() => import('./components/ContactUs'));
const FAQ = lazy(() => import('./components/FAQ'));

// Loading component for Suspense fallback
const Loading = () => (
  <div className="flex items-center justify-center min-h-screen bg-background">
    <div className="animate-pulse text-2xl font-crayon text-foreground">
      Loading...
    </div>
  </div>
);

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <Toaster
          position="top-center"
          richColors
          closeButton
          toastOptions={{
            style: {
              fontFamily: 'Poppins, sans-serif',
            },
            className: 'font-story',
          }}
        />
        <Suspense fallback={<Loading />}>
          <Routes>
            <Route path="/" element={<Navigate to="/home" replace />} />
            <Route path="/home" element={<Layout><LandingPage /></Layout>} />
            <Route path="/create" element={<Layout><BedtimeStoryGenerator /></Layout>} />
            <Route path="/privacy" element={<Layout><PrivacyPolicy /></Layout>} />
            <Route path="/terms" element={<Layout><TermsOfService /></Layout>} />
            <Route path="/contact" element={<Layout><ContactUs /></Layout>} />
            <Route path="/faq" element={<Layout><FAQ /></Layout>} />
          </Routes>
          <Analytics />
        </Suspense>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
